<template>
  <v-container fill-height justify-center>
    <v-dialog max-width="400" v-model="showOtpEmailDialog">
      <v-card>
        <v-card-title>
          {{ $t("modal.otpEmail.title") }}
        </v-card-title>
        <v-card-text v-html="$t('modal.otpEmail.description')" />
        <v-form ref="otpEmailDialog" v-model="otpEmailValid">
          <v-card-actions>
            <v-text-field
              type="email"
              :placeholder="$t('modal.otpEmail.placeholder')"
              v-model="otpEmail"
              required
              :rules="emailRules"
            />
          </v-card-actions>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="showOtpEmailDialog = false">
            {{ $t("modal.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!otpEmailValid"
            @click="debouncedOpenDoor(otpEmail), (showOtpEmailDialog = false)"
            >{{ $t("modal.continue") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12>
        <div
          v-if="onekeyappRequired"
          class="display-1 text-center"
          v-html="$t('app.openOneKey')"
        />
        <div
          v-else
          class="display-1 text-center"
          v-html="$t('app.yourRoom', { number: authResult.room })"
        />
      </v-flex>
      <v-flex xs12>
        <v-layout justify-center class="text-center pa-4">
          <v-card color="transparent" flat style="max-width: 100%">
            <form name="param" method="GET">
              <v-btn
                v-if="otpEmailRequired"
                color="primary"
                fab
                style="width: 200px; height: 200px"
                data-v-step="key_0"
                @click="showOtpEmailDialog = true"
              >
                <v-layout align-center justify-center>
                  <v-icon size="160px">mdi-open-in-app</v-icon>
                </v-layout>
              </v-btn>
              <template v-else>
                <v-btn
                  color="primary"
                  fab
                  style="width: 200px; height: 200px"
                  data-v-step="key_0"
                  @click="debouncedOpenDoor()"
                >
                  <v-layout align-center justify-center>
                    <v-icon v-if="onekeyappRequired" size="160px">
                      mdi-open-in-app
                    </v-icon>
                    <v-icon v-else size="160px">mdi-lock-open</v-icon>
                  </v-layout>
                </v-btn>
                <div class="mt-4 body-1 text-secondary font-italic text-center">
                  {{ $t("mobileKey.help") }}
                </div>
              </template>
            </form>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        v-if="
          saltoShipRoomList &&
          saltoShipRoomList.otherDoors &&
          saltoShipRoomList.otherDoors.length
        "
      >
        <v-card class="mt-4 mx-auto" flat max-width="500">
          <v-card-title class="headline">
            {{ $t("mobileKey.otherDoors") }}
          </v-card-title>
          <v-list two-line>
            <v-list-item
              v-for="(door, idx) in saltoShipRoomList.otherDoors"
              :key="door.externalDoorId || idx"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ getDoorName(door) }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  color="primary"
                  icon
                  @click="openOtherDoor(door)"
                  :title="$t('mobileKey.openDoor')"
                  :loading="saltoShipRoomListLoading"
                  :disabled="saltoShipRoomListLoading"
                >
                  <v-icon>mdi-lock-open</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 v-else-if="saltoShipRoomListLoading" class="mt-4 px-4">
        <v-skeleton-loader
          type="heading"
          class="mx-auto mb-4"
          max-width="500"
        />
        <v-skeleton-loader type="list-item" class="mx-auto" max-width="500" />
        <v-skeleton-loader type="list-item" class="mx-auto" max-width="500" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MobileDetect from "mobile-detect";
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      isIos: false,
      demoMesserschmitt: {
        mainAndroidLink:
          "intent:#Intent;action=com.messerschmitt.launchfrombrowser;package=com.messerschmitt.demoatvision;category=android.intent.category.DEFAULT;category=android.intent.category.BROWSABLE;",
        parm1: "S.param1=",
        parm2: "S.param2=",
        endP: "end;",
        token: "test_device_identifier",
        key:
          "eyJ2YWxpZCI6MSwicmVhc29uIjotMSwic2MiOjg1LCJybSI6W3sibCI6IjEiLCJwIjoxfV0sInNhIjpbMjU1LDI1NSwyNTUsMjU1LDI1NSwyNTUsMjU1LDI1NSwyNTUsMjU1LDI1NSwyNTUsMjU1LDI1NSwyNTUsMjU1XSwiZHQiOlsxNDAsMiwyNTMsMSwyNTQsMTk1LDk4LDQyLDYwLDE1NCwyMzcsODMsMTI0LDczLDEwOCwxMzksNDEsMjM2LDE4NCwxMzEsODIsMzIsMTYsMTM1LDE1MCw5NSw4LDI2LDc0LDIxMSw5LDIzMSwxMzEsMTc3LDEyNCwxMjIsMTM1LDIyNSw3NCwxOTldLCJkYSI6IjIwMjAtMDQtMzBUMTg6MDArMDA6MDAiLCJnIyI6IiJ9",
      },
      onekeyappRequiredVendors: ["assa_abloy", "messerschmitt"],
      otpEmailRequiredVendors: ["assa_abloy"],
      showOtpEmailDialog: false,
      otpEmail: "",
      otpEmailValid: false,
    };
  },
  mounted() {
    const md = new MobileDetect(window.navigator.userAgent);
    this.isIos = md.os() === "iOS";
    if (this.vendor === "salto" && this.saltoUseShip) {
      this.fetchSaltoShipRoomList({ roomNumber: this.authResult.room });
    }
  },
  computed: {
    onekeyappRequired() {
      return this.onekeyappRequiredVendors.find((o) => o === this.vendor);
    },
    otpEmailRequired() {
      return this.otpEmailRequiredVendors.find((o) => o === this.vendor);
    },
    ...mapState({
      authResult: ({ session }) => session.authResult,
      vendor: ({ session }) => session.settings?.onekey?.vendor,
      saltoUseShip: ({ session }) => session.settings?.onekey?.saltoUseShip,
      saltoShipRoomList: (rootState) => rootState.onekey.saltoShipRoomList,
      saltoShipRoomListLoading: (rootState) =>
        rootState.onekey.saltoShipRoomListLoading,
    }),
    emailRules() {
      return [
        !!this.otpEmail || this.$t("general.emailRequired"),
        /.+@.+\..+/.test(this.otpEmail) || this.$t("general.emailNotValid"),
      ];
    },
  },
  watch: {
    otpEmail(val) {
      if (!val) {
        this.$refs.otpEmailDialog.resetValidation();
      }
    },
  },
  methods: {
    ...mapActions("onekey", ["openDoor", "fetchSaltoShipRoomList"]),

    debouncedOpenDoor: debounce(
      function (email = null) {
        if (email) {
          this.openDoor({ otpEmail: email });
        } else {
          this.openDoor();
        }
      },
      5000,
      { leading: true, trailing: false }
    ),
    getDoorName(door) {
      const currentLang = this.$i18n.locale || "en";
      const found =
        door.i18n.find((i) => i.language === currentLang && i.text) ||
        door.i18n.find((i) => i.language === "en" && i.text) ||
        door.i18n.find((i) => i.text);
      return found ? found.text : door.roomNumber;
    },
    openOtherDoor(door) {
      this.openDoor({ roomNumber: door.roomNumber });
    },
  },
};
</script>
